export { getAnonUserId, isMobileBrowser, extractDigits, getHostnameFromURL } from './utils';
